/*****************************************************************************
 *
 * Number to String formatters used throughout the application
 *
 *****************************************************************************/

import {TEXT} from "./strings";

const TRILLION = 1000000000000;
const BILLION = 1000000000;
const MILLION = 1000000;

const DECIMAL = new Intl.NumberFormat('en', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2
});

const INTEGER = new Intl.NumberFormat('en', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0
});

/**
 *
 * Returns numbers formatted based on their size, rounded to Trillion, Billion, or Million
 * if the numbers exceed those corresponding thresholds.
 *
 * K thousands rounding was intentionally omitted by requirements
 *
 * Over 1 Trillion: divided by 1 trillion, rounded to 2 decimal places, add 'T' suffix
 * Over 1 Billion: divided by 1 billion, rounded to 2 decimal places, add 'B' suffix
 * Over 1 Million: divided by 1 trillion, rounded to 2 decimal places, add 'M' suffix
 * Under 1 Million: rounded to 0 decimal places, comma thousands separators
 *
 * If value isNaN, returns '---'
 *
 * @param value
 * @returns {string}
 */
export const formatKMBT = (value) => {

  if (isNaN(value)) {
    return TEXT.suppressed_data_abbr;
  }

  if (value >= TRILLION) {
    return DECIMAL.format(value / TRILLION) + " T"
  }
  else if (value >= BILLION) {
    return DECIMAL.format(value / BILLION) + " B"
  }
  else if (value >= MILLION) {
    return DECIMAL.format(value / MILLION) + " M"
  }
  else {
    return INTEGER.format(value)
  }
};


/**
 * Format numbers as US Currency based on their size, rounded to
 * Trillion, Billion, or Million if the numbers exceed those
 * corresponding thresholds.
 *
 * @param value
 * @returns {string}
 */
export const formatCurrencyKMBT = (value) => {
  if (isNaN(value)) {
    return TEXT.suppressed_data_abbr;
  }

  return "$" +  formatKMBT(value)
};

/**
 * Format numbers as US Currency: rounded to 0 decimal places, comma thousands separators, $ prefix
 *
 * @param value
 * @returns {string}
 */
export const formatCurrency = (value) => "$" +  formatInteger(value)

/**
 * Format numbers with comma thousands separators and rounded to 0 decimal places
 *
 * @param value
 * @returns {string}
 */
export const formatDecimal = (value) => DECIMAL.format(value)

/**
 * Format numbers with comma thousands separators and rounded to 2 decimal places
 *
 * @param value
 * @returns {string}
 */
export const formatInteger = (value) => INTEGER.format(value)


